<template>
  <div class="News" id="News">
    <v-app>
      <v-app-bar app color='primary' dark height="564" absolute>
        <v-row align="start">
          <!-- 一级导航栏 -->
          <FirstNavbar :pc='pc' :tab_index="first_active_tab" :barHide="barHide" :barColor="barColor"></FirstNavbar>
          <div class='first_title_box'  style="width:100%;height:calc(564px - 64px);" >
            <v-row align="center" justify="center">
              <v-col cols="12">
                <h1 class="first_title white--text">
                  嘉旭福美数字经济产业园
                </h1>
                <h4 class="body_text white--text">
                  <span>诚信</span><span>规范</span><span>创新</span><span>高效</span>
                </h4>
              </v-col>
            </v-row>
          </div>
          <!-- 首屏大图 -->
          <div style="width:100%;height:500px;position:absolute;z-index:-3;margin-left:-4px">
            <v-parallax height="564" dark src="../assets/images/数字经济产业园顶部.png">
            </v-parallax>
          </div>
        </v-row>
      </v-app-bar>
      <v-main>
        <div class="aboutContent">
          <v-row dense>
            <v-col cols="12">
              <BoxTitle firstTitle="嘉旭福美数字经济产业园" :index="1"></BoxTitle>
              <div class='content'>
                <h2 class='title'>1、大数据产业园区</h2>
                <p class='body_text'>开展云计算应用和技术的研究，为数字经济的应用提供云平台支撑</p>
                <p class='body_text'>构建组件化的大数据应用平台，提供数据共享、数据分析、数据安全在数字经济发展的创新应用。</p>
                <p class='body_text'>建设大数据交易平台，推进大数据交易发展，连通大数据供需双方，形成数据技术和产业创新发展新模式。</p>
                <div class="imgBox">
                  <img src='../assets/images/chanyeyuan3.png'>
                </div>
                <h2 class='title'>2、数字资源应用示范园区</h2>
                <h4 class='subtitle'>（1）建设数字资源中心</h4>
                <p class='body_text'>开展数据采集服务，面向行业应用采集电商、社交、块数据等社会数据，以及特色行业的专业数据和地理信息数据。</p>
                <h4 class='subtitle'>（2）数字清洗加工中心</h4>
                <p class='body_text'>开展数据清洗加工分析业务，建立数据清洗加工基地。进行数据清洗、脱敏、建模、分析、挖掘、可视化等数据服务。推进新型数据挖掘技术应用，建设数据分析服务平台。</p>
                <div class="imgBox">
                  <img src='../assets/images/chanyeyuan4.png'>
                </div>
                <h2 class='title'>3、数字创新融合应用园区</h2>
                <h4 class='subtitle'>（1）院士工作站</h4>
                <p class='body_text'>以国家科学数据应用和数字经济发展研究为主线，为企业或区域内研究发展方向，提供顶层设计。</p>
                <p class='body_text'>以中国科学院院士、中国工程院院士及其团队为核心，以研发机构为依托，联合进行科学技术研究的高层次科技创新平台。院士工作站旨在促进科技成果产业化，培养创新人才队伍，为增强自主创新能力提供强有力的支撑。</p>
                <p class='body_text'>围绕企业发展重大关键技术环节，组织院士及其创新团队与企业技术人员联合研发，研究数字经济领域重大理论、方法和重大创新技术、培育企业自主知识产权和自主品牌，为区域内和企业发展提供智力支撑。</p>
                <h4 class='subtitle'>（2）博士后企业工作站</h4>
                <p class='body_text'>培养引进大数据、数字经济高端创新人才，引进转化院士及其创新团队新技术成果。积极推动指导企业对新型虚拟化、大规模并行分析等核心技术研发，拓展云计算产业链条，推动企业超前布局区块链条、太赫兹、超大数据等新领域，搭建云计算、边缘计算等多元普惠计算设施、为社会和企业提供高效、安全的云计算标准核心技术平台。</p>
                <h4 class='subtitle'>（3）国家地球科学数据共享平台定兴基地</h4>
                <p class='body_text'>依托中国科学院地理科学与资源研究院所国家地球科学数据共享平台，建设国家地球科学数据平台定兴基地，开展国家地球科学数据战略备份，为雄安新区建设绿色智慧新城提供高效安全的大数据平台，实现对大气环境、水资源、土壤、林业资源监测以及生态环境安全评价，为雄安新区及上游地区自然地理、生态建设、经济社会发展，环境保护提供数据资源。</p>
                <h4 class='subtitle'>（4）航天生物工程大数据示范应用基地</h4>
                <p class='body_text'>依托中国空间技术研究院、航天神州生物科技集团有限公司等科研单位，开展航天生物工程大数据示范应用。建立航天育种种质资源数据库，为空间微重力等特殊因素引导的生物基金突变在育种、空间诱变效应、植物新品种培育和航天工程育种机理研究等前沿科学研究提供科学数据支撑。</p>
                <h4 class='subtitle'>（5）国际化大数据创新与应用人才培养基地</h4>
                <p class='body_text'>依托国家外专局、国家林业局、国家发改委培训中心等联合立项支持，成立大数据和信息产业人才培养专项基金，培养国际化“两高一尖”人才：高水平大数据专业技术人员、高水平大数据产业管理人才和尖端大数据研发人才，为雄安新区及京津冀地区人才培养服务。旨在对提升我国大数据创新应用技能人才培养，促进大数据创新应用技能推广和应用。</p>
                <h4 class='subtitle'>（6）数据应用研究院</h4>
                <p class='body_text'>以生态观测数据研究、气象数据应用研究、新型数字技术研究、数字经济应用研究为主线，开展新一代数字技术的应用研究。研究数据建模技术工具、数据挖掘技术方法。探索数据在数字经济中的资源利用、融合应用、服务应用等新价值</p>
                <div class="imgBox">
                  <img src='../assets/images/chanyeyuan5.png'>
                </div>
          </div>
            </v-col>
          </v-row>
        </div>
      </v-main>
      <v-footer  color="secondary" style="height:auto">
        <FootContent :active="footList.active" :listWidth="footList.listWidth"></FootContent>
      </v-footer>
    </v-app>
  </div>
</template>

<script>
import FootContent from '../components/footer.vue'
import FirstNavbar from '../components/first-navbar.vue'
import BoxTitle from '../components/box-title.vue'

export default {
  name: 'yuanqu',

  components: {
    FootContent,
    FirstNavbar,
    BoxTitle
  },
  data: () => ({
    // 导航背景颜色
    barColor: 'rgba(63, 81, 181,0)',
    // 导航栏是否隐藏
    barHide: true,
    // 是否为PC端
    pc: false,
    // 悬浮按钮是否隐藏
    floatHidden: true,
    // 一级导航选项卡
    first_active_tab: 0,
    // 页脚参数
    footList: {
      listWidth: '10rem',
      active: [true, true, true]
    },
    contentHtml: ''
  }),
  created () {
    this.$nextTick(() => {
    })
  },
  mounted () {
    this.goTo(0)
    var that = this
    that.whatScreen()
    // 屏幕尺寸监听
    window.onresize = function () {
      that.whatScreen()
    }
  },
  methods: {
    // 屏幕
    whatScreen () {
      var width = document.querySelector('html').offsetWidth
      if (width <= 768) {
        // title.innerHTML = "极小屏幕-" + width
        this.footList.active = [false, false, false]
        this.footList.listWidth = '90rem'
        this.pc = false
      } else {
        if (width > 768 && width <= 992) {
          // title.innerHTML = "小屏幕-" + width
          this.footList.active = [true, true, true]
          this.footList.listWidth = '10rem'
          this.pc = false
        } else {
          if (width > 992 && width <= 1100) {
            // title.innerHTML = "普通屏幕-" + width
            this.footList.active = [true, true, true]
            this.footList.listWidth = '10rem'
            this.pc = true
          } else {
            if (width > 1200 && width <= 1600) {
              // title.innerHTML = "大屏幕-" + width
              this.footList.active = [true, true, true]
              this.footList.listWidth = '10rem'
              this.pc = true
            } else {
              if (width > 1600) {
                // title.innerHTML = "大屏幕-" + width
                this.footList.listWidth = '10rem'
                this.footList.active = [true, true, true]
                this.pc = true
              }
            }
          }
        }
      }
    },
    // 一级导航跳转定位
    toguid (path_, id) {
      const path = path_
      const Id = id
      localStorage.setItem('toId', Id)
      this.$router.push(path)
    },
    goTo (ele) {
      document.body.scrollTop = ele
      document.documentElement.scrollTop = ele
    }
  }

}
</script>

<style scoped>
.content .title{
    font-size: 2.3rem;
    line-height: 3.6rem;
    margin-bottom:1rem;
    color:var(--fontColor)
}
.content .subtitle{
    font-size: 1.05rem;
    line-height: 1.5rem;
    margin-bottom: 1rem;
    font-weight: 400;
    text-indent:1.15rem;
    color:var(--fontColor)
}
.content > p{
    text-indent: 2.3rem;
}
.content > .imgBox{
    width:100%;
    position:relative;
    display:flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
}
.content > .imgBox > img{
    height:23rem;
    margin:1rem;
}
</style>
